import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, effect, inject, ViewChild } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { InfosGuidanceComponent } from '../../../components/infos-guidance/infos-guidance.component';
import { LoadingSpinnerComponent } from '../../../components/loading-spinner/loading-spinner.component';
import { RepairerSiteHistory } from '../../../model/user.model';
import { DatePipe } from '../../../pipes/date.pipe';
import { TimePipe } from '../../../pipes/time.pipe';
import { CurrentUserService } from '../../../services/currentUser.service';
import { LocationAdminStore } from '../location.admin.store.component';

@Component({
  selector: 'history-of-company',
  templateUrl: './history-of-company.component.html',
  imports: [
    NgTemplateOutlet,
    NgClass,
    DatePipe,
    MatSortModule,
    MatDividerModule,
    MatTableModule,
    MatButtonModule,
    TimePipe,
    InfosGuidanceComponent,
    LoadingSpinnerComponent
  ]
})
export class HistoryOfCompanyComponent {
  @ViewChild(MatSort) set sort(matSort: MatSort) {
    this.dataSource.sort = matSort;
  }

  columnHeaders = ['transactionDateTime', 'event', 'details'];
  dataSource: MatTableDataSource<RepairerSiteHistory> = new MatTableDataSource();
  activeColumn = 'transactionDateTime';
  locationAdminStore = inject(LocationAdminStore);
  currentUserService = inject(CurrentUserService);

  noChangeHistoryEvents = [
    'Repairer Site Suspended',
    'Repairer Site Restored',
    'Overdue license fee cleared',
    'Flagged for overdue license fee'
  ];

  constructor() {
    effect(() => {
      if (this.locationAdminStore.repairerSiteHistories().length) {
        this.dataSource.data = this.locationAdminStore.repairerSiteHistories();
        this.dataSource.sort = this.sort;
      }
    });
  }
}
